import React from "react";

import AboutPhoto from "./AboutPhoto";
import irelandImage from "../../images/team-photo-workshop.jpg";
import skrzyczneImage from "../../images/team-photo-skrzyczne.jpg";
import marathonImage from "../../images/team-photo-marathon.jpg";

function AboutPhotos() {
  return (
    <div className="about__photos">
      <AboutPhoto img={irelandImage} caption="Workshop, Ireland 2019" />
      <AboutPhoto img={skrzyczneImage} caption="Mountain trip 2018" />
      <AboutPhoto img={marathonImage} caption="Company Run 2019" />
    </div>
  );
}

export default AboutPhotos;
